import { AssessmentExportRequestData } from 'src/app/ai-assessments/models/assessment-export.interface';
import { ContentSchema } from '../services/content/content-schema.interface';
import { CopyReportExportRequestData } from '../dsr/dsr-ticket/dsr-ticket-content/dsr-ticket-reply/dsr-ticket-collection-reply/dsr-copy-repot.interfact';

export enum ExportTypeEnum {
	Assessment = 'assessment',
    CopyReport = 'copyReport'
}

export interface PdfConversionRequest {
    exportType: ExportTypeEnum;
    title: string;
    data: PdfConversionRequestData;
    squidexContents: ContentSchema[];
    /** 'docx' makes the reports service return a Word document (rendered PDF converted via
     *  pdf-to-docx); omitted/'pdf' returns the PDF as before. */
    format?: 'pdf' | 'docx';
}

export type PdfConversionRequestData = AssessmentExportRequestData | CopyReportExportRequestData;